import { PoolType } from '../types/base';
export const DEFAULT_USER_CONFIG = {
    // FIXME: V3 pools are not supported yet
    // poolTypes: [
    //   PoolType.V2,
    //   PoolType.V3_100,
    //   PoolType.V3_500,
    //   PoolType.V3_3000,
    //   PoolType.V3_10000,
    // ],
    poolTypes: [PoolType.V2],
    maxHops: 2,
    maxSplits: 2,
    slippageTolerance: 0.005,
};
